
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic15On as ObiHydraulic15OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-15-on.js';
 
 
 

 
 export const ObiHydraulic15On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-15-on',
   elementClass: ObiHydraulic15OnElement,
   events: {
     
   }
  });
 
 